import { Text } from '@perch-labs/shrike';
import React, { useState } from 'react';
import { StyledBadge } from 'pages/dashboard/impact-modules/styled-module/styled-module.style';
import { BackgroundColors } from '@perch-labs/shrike/dist/types/src/types';
import { headerStyle, rowStyle, PlaceholderImage } from './lmi-table.style';

interface RowProps {
  rowData: {
    proofDocUrls: (string | null)[];
    proofDocName: string | null;
    proofDocStatus: string | null;
    proofDocUploadedAt: string | null;
    uaLmiSourceTypeId: number | null;
    utilityAccountId: number | null;
    utilityName: string | null;
    utilityAccountNumber: string | null;
    utilityServiceAddress: string | null;
  } | null;
}

interface ImageProps {
  proofDocUrls?: (string | null)[];
}
export const LmiTableHeader = () => {
  return (
    <tr style={{ position: 'sticky', top: 0, backgroundColor: '#FFFFFF' }}>
      <th style={{ ...headerStyle, minWidth: '120px' }}>
        {' '}
        <Text color="primary" textStyle="heading400">
          File(s)
        </Text>
      </th>
      <th style={headerStyle}>
        <Text color="primary" textStyle="heading400">
          Program
        </Text>
      </th>
      <th style={headerStyle}>
        <Text color="primary" textStyle="heading400">
          Uploaded
        </Text>
      </th>
      <th style={{ ...headerStyle, minWidth: '232px', maxWidth: '232px' }}>
        <Text color="primary" textStyle="heading400">
          Utility account
        </Text>
      </th>
      <th style={headerStyle}>
        <Text color="primary" textStyle="heading400">
          Status
        </Text>
      </th>
    </tr>
  );
};

export const LmiStyledRowChild = (props: RowProps) => {
  const { rowData } = props;
  return (
    <>
      <td style={rowStyle}>
        {' '}
        <LmiImage proofDocUrls={rowData?.proofDocUrls} />
      </td>
      <td style={rowStyle}>
        {' '}
        <Text color="secondary" textStyle="heading400">
          {rowData?.proofDocName
            ?.replace(/_non_ira/g, '')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, c => c.toUpperCase())}
        </Text>
      </td>
      <td style={rowStyle}>
        {' '}
        <Text color="secondary" textStyle="heading400">
          {rowData?.proofDocUploadedAt}
        </Text>
      </td>
      <td style={rowStyle}>
        {' '}
        <Text color="secondary" textStyle="heading400">
          {rowData?.utilityName} #{rowData?.utilityAccountNumber} (
          {rowData?.utilityServiceAddress})
        </Text>
      </td>
      <td style={rowStyle}>
        {' '}
        <LmiStatus status={rowData?.proofDocStatus || ''} />
      </td>
    </>
  );
};

const LmiStatus = (props: { status: string }) => {
  let backgroundColor: BackgroundColors = 'warning';
  switch (props.status) {
    case 'verified':
      backgroundColor = 'success';
      break;
    case 'rejected':
      backgroundColor = 'error';
      break;
    default:
      break;
  }
  return (
    <StyledBadge backgroundColor={backgroundColor} size="medium">
      {props.status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
    </StyledBadge>
  );
};

const LmiImageDisplay = (props: { url: string; index: number }) => {
  const { url, index } = props;
  const [isError, setIsError] = useState(false);
  if (isError) {
    return (
      <a
        href={url}
        key={index}
        style={{
          display: 'block',
          margin: '10px 0',
        }}
        target="_blank"
        rel="noopener noreferrer"
        onClick={e => {
          e.preventDefault();
          window.open(url, '_blank');
        }}
      >
        lmi_proof_doc
      </a>
    );
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" key={index}>
      <img
        alt="lmi_proof_doc"
        src={url}
        width="40px"
        height="40px"
        onError={() => setIsError(true)}
        style={{
          borderRadius: '8px',
          margin: index % 2 === 0 ? '0px 8px 0px 0px' : '0px',
        }}
        onClick={e => {
          e.preventDefault();
          window.open(url, '_blank');
        }}
      />
    </a>
  );
};

const LmiImage = (props: ImageProps) => {
  return props.proofDocUrls!.length > 0 ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {props.proofDocUrls?.map((url: string, index: number) => (
        <LmiImageDisplay key={index} url={url || ''} index={index} />
      ))}
    </>
  ) : (
    <PlaceholderImage />
  );
};
